class VariantSelects extends HTMLElement {
  constructor() {
    super();
    if (!window.location.search.includes('?variant=')) {
      this.querySelectorAll('.swatches-size input:checked').forEach((input) => {
        input.checked = false;
      });
    }

    this.addEventListener('change', () => {
      this.onVariantChange(this);
    });
  }

  onVariantChange(event) {
    // check if the user has selected all options (1 option per select)
    if (!this.checkIfAllOptionsAreSelected()) {
      // this.toggleAddButton(false, '', true);
      return;
    }

    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updateURL();

    if (!this.currentVariant) {
      //if there is no current variant, we need to disable the add button and show the user that the product is unavailable
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      //if there is a current variant, we need to update the media, url, variant input, and product info
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.dispatchVariantChange();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  checkIfAllOptionsAreSelected() {
    const fieldSets = Array.from(this.querySelectorAll('fieldset'));
    const checkedInputs = this.querySelectorAll('input:checked');
    return fieldSets.length === checkedInputs.length;
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  dispatchVariantChange() {
    document.dispatchEvent(
      new CustomEvent('variant-change', {
        bubbles: true,
        variant: this.currentVariant,
        detail: {
          variant: this.currentVariant,
        },
      })
    );
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `#price-${this.dataset.section}`;
        const idName = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destinations = document.querySelectorAll(id);

        destinations.forEach((destination) => {
          const source = html.getElementById(idName);

          if (source && destination) destination.innerHTML = source.innerHTML;

          document
            .getElementById(`price-${this.dataset.section}`)
            ?.classList.remove('visibility-hidden');
          if (this.currentVariant) {
            this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
          }
        });
      });
  }

  toggleAddButton(disable, text, modifyClass = true) {
    const addButton = document.querySelector('.product-form .button-add-to-cart');
    const toggleStickyBtn = document.querySelector('[data-form-toggle]');

    if (!addButton) return;

    if (!toggleStickyBtn.classList.contains('visibility-hidden')) {
      toggleStickyBtn.classList.add('visibility-hidden');
    }

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (this.checkIfAllOptionsAreSelected()) {
        if (text) addButton.textContent = text;
      } else {
        addButton.textContent = window.variantStrings.selectYourProduct;
      }
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const selectedValue = Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked
      );
      // Check if there is a selected value
      return selectedValue ? selectedValue.value : null;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
